<template>
    <svg :fill=fill xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <path
            d="m8,16c-.93,0-1.81-.15-2.64-.44s-1.58-.7-2.26-1.24l-1.4,1.38c-.18.18-.42.28-.7.28s-.52-.09-.7-.28-.28-.42-.28-.7.09-.52.28-.7l1.38-1.38c-.53-.68-.95-1.44-1.24-2.28s-.44-1.72-.44-2.65C0,5.77.78,3.88,2.33,2.33S5.77,0,8,0h8v8c0,2.23-.78,4.13-2.33,5.68s-3.44,2.33-5.68,2.33Zm0-2c1.67,0,3.08-.58,4.25-1.75s1.75-2.58,1.75-4.25V2h-6c-1.67,0-3.08.58-4.25,1.75s-1.75,2.58-1.75,4.25c0,.65.1,1.27.3,1.86s.48,1.13.83,1.61l5.18-5.18c.18-.18.42-.28.7-.28s.52.09.7.28c.2.2.3.44.3.71s-.1.51-.3.71l-5.18,5.18c.48.35,1.02.62,1.61.81.59.19,1.21.29,1.86.29Z" />
    </svg>
</template>

<script>
export default {
    name: "IconEv",

    props: {
        fill: {
            type: String,
            default: 'black'
        }
    }
}
</script>